"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getCountries", {
  enumerable: true,
  get: function get() {
    return _props.getCountries;
  }
});
Object.defineProperty(exports, "getCountryCodes", {
  enumerable: true,
  get: function get() {
    return _props.getCountryCodes;
  }
});

var _props = require("./props");


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/functions/countries.js
// module id = 340
// module chunks = 168707334958949